import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { MARKETING_CHANNEL_ID } from '../theme/theme.constants';

/**
 * Returns the user brand companies from personal information endpoint.
 * @returns Banbrand list array or brand list joined.
 */
export const useUserBrands = () => {
  const store = useSelector(({ personalInformation }) => ({
    personalInformation,
  }), shallowEqual);

  const { personalInformation: { userInfo } } = store;

  const userBrandCompanies = useMemo(() => {
    if (!userInfo || !userInfo.Companies) {
      return [];
    }

    const companies = userInfo.Companies
      .map((company) => company.OriginId) || [];

    return companies;
  }, [userInfo]);

  const userBrandCompaniesJoined = useMemo(() => userBrandCompanies
    .join(','), [userBrandCompanies]);

  const hasPolicyPPU = useMemo(() => {
    const ppuCompany = userInfo
      .Companies?.find(({ Id }) => Id === MARKETING_CHANNEL_ID.ppu);

    return Boolean(ppuCompany);
  }, [userInfo]);

  const hasOnlyPPU = useMemo(() => !userInfo?.Companies
    ?.some(({ Id }) => Id !== MARKETING_CHANNEL_ID.ppu), [userInfo]);

  return {
    hasOnlyPPU,
    hasPolicyPPU,
    userBrandCompanies,
    userBrandCompaniesJoined,
  };
};
